import React from 'react';
import Robot from './robot.js';
import '../css/team.css';

const Team = (props) => {
  const robots = props.robots.map(robot => 
    <Robot {...robot} key={robot.robotName} />
  );

  return (
    <div className="team">
      <div className="team-info">
        <h1>{props.teamName}</h1>
        <h2>{props.userName}</h2>
        <a href={props.postURL}>Signup Post</a>
      </div>
      <div className="robots">
        {robots}
      </div>
    </div>
  );
};

export default Team;


// WEBPACK FOOTER //
// ./src/components/team.js